import store from '@/redux/store'

const collaborationHeader = 'collaboration-id'

const getCollaborationRequestHeader = (collaborationId) => {
  if (collaborationId) return { [`${collaborationHeader}`]: collaborationId }
  const { currentCollaboration } = store.getState().document.list
  if (!currentCollaboration || currentCollaboration === 'internal') return {}
  return { [`${collaborationHeader}`]: currentCollaboration }
}

export default getCollaborationRequestHeader
